// komponent Table - lokalny override
// Dodaje globalnie komunikat "Nie znaleziono wyników" gdy tabela nie ma wierszy.
// Deleguje całe renderowanie do tabeli z core, a komunikat dokłada pod nią.
// @ts-nocheck

import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import CoreTable from '@core/components/controls/Table/Table';
import styles from './Table.module.scss';

export type {
  IColumn,
  ISorter,
} from '@core/components/controls/Table/Table';

const Table = <T extends Record<string, any>>(props): ReactElement => {
  const { t } = useTranslation();
  const isEmpty = (props?.dataSource?.length ?? 0) === 0;

  return (
    <>
      <CoreTable<T> {...props} />
      {isEmpty && (
        <div className={styles.emptyState}>{t('Nie znaleziono wyników')}</div>
      )}
    </>
  );
};

export default Table;
